import { BaseEntity } from "./BaseEntity";
import { InternshipSchedule } from "./InternshipSchedule";
import { SkillCriteria } from "./SkillCriteria";
import { Gesture } from "./Gesture";

export class InternshipScheduleSkill extends BaseEntity {
    public internshipSchedule: string | InternshipSchedule = "";
    public skillCriteria: string | SkillCriteria = "";
    public gestures: string[] | Gesture[] = [];

    constructor(model: Partial<InternshipScheduleSkill> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PInternshipScheduleSkill = Partial<InternshipScheduleSkill>;
